import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { FileDownloadSummaryApiModel } from '../accounts/models/file-download-summary-api.model';


@Injectable()
export class FileDownloadsApi {

    constructor(private neptuneApi: NeptuneApi) {}

    /**
     * get a list of files file download page
     */
    getQueuedFiles(): Observable<FileDownloadSummaryApiModel[]> {
        const slug = '/filedownloads/monitoring';
        return this.neptuneApi.api<FileDownloadSummaryApiModel[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    getFile(id: string): Observable<FileDownloadSummaryApiModel> {
        const slug = `/filedownloads/monitoring/${id}`;
        return this.neptuneApi.api<FileDownloadSummaryApiModel>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * get options for social post exported fields
     */
    public getPostExportFields(): Observable<any> {
        return this.neptuneApi.api(
            '/filedownloads/monitoring/options',
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * get options for social post exported fields
     */
    public getUnsavedMentionQuotaUsage(): Observable<number> {
        return this.neptuneApi.api(
            '/filedownloads/monitoring/mentions/usedQuota',
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * export social posts
     */
    public exportPosts(body: any): Observable<any> {
        return this.neptuneApi.api(
            '/filedownloads/monitoring',
            body,
            HttpVerbsEnum.POST
        );
    }

    /**
     * delete a file from file download page
     */
    deleteQueuedFile(id: string): Observable<void> {
        const slug: string = `/filedownloads/monitoring/${id}`;
        return this.neptuneApi.api<void>(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
